export default "__VITE_ASSET__D12ZdnLU__"